import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=8f0d036e&scoped=true"
import script from "./TableBody.vue?vue&type=script&lang=js"
export * from "./TableBody.vue?vue&type=script&lang=js"
import style0 from "./TableBody.vue?vue&type=style&index=0&id=8f0d036e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0d036e",
  null
  
)

export default component.exports